import { useEffect, useState } from 'react';

import { Image } from 'antd';
import { useQuery } from '@apollo/client';

import { FETCH_CORPORATE_LOGO } from '../pages/dataInputs/queries';
import { FetchError, Loading } from './index';

interface DataReturned {
  findAllBcpCorporates: [
    {
      corporateLogo: string;
      uuid: string;
    },
  ];
}

export function CorporateLogo() {
  const [logo, setLogo] = useState(() => localStorage.getItem('corporateLogo'));

  const { data, loading, error } = useQuery<DataReturned>(
    FETCH_CORPORATE_LOGO,
    { skip: !!logo },
  );

  useEffect(() => {
    const logoSrc = data?.findAllBcpCorporates[0]?.corporateLogo;

    if (!logoSrc || logo) return;

    localStorage.setItem('corporateLogo', logoSrc);
    setLogo(logoSrc);
  }, [data, logo]);

  if (loading) return <Loading />;

  if (error) return <FetchError error={error.message} />;

  return (
    <Image src={logo || ''} alt="Corporate Logo" preview={false} width={160} />
  );
}
